module.exports = __webpack_public_path__ + "img/5.cc976a89.png";